import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { logger } from "@/lib/logger";

// Admin-only header signals: locked-account count, pending device approvals, last backup timestamp.
export function useAdminHealth(role, lockoutTick, deviceTick = 0) {
  const [lockoutCount, setLockoutCount] = useState(0);
  const [pendingDevices, setPendingDevices] = useState(0);
  const [lastBackupAt, setLastBackupAt] = useState(null);
  const refresh = useCallback(() => {
    if (role !== "admin") return;
    api.get("/users/security-alerts").then((r) => setLockoutCount((r?.alerts || []).length)).catch((e) => logger.error("security-alerts:", e));
    api.get("/auth/devices").then((r) => setPendingDevices((r?.attempts || []).length)).catch((e) => logger.error("auth/devices:", e));
    api.get("/admin/backups/last").then((r) => setLastBackupAt(r?.last_backup_at || null)).catch((e) => logger.error("backups/last:", e));
  }, [role, setLockoutCount, setPendingDevices, setLastBackupAt]);
  useEffect(() => { refresh(); }, [refresh, lockoutTick, deviceTick]);
  return { lockoutCount, pendingDevices, lastBackupAt, refresh };
}
